import { CommentsStore } from '../Comments/CommentsStore';
import { UrlProvider } from "../../Infrastructure/UrlProvider";
import { DeliveryIndentifier } from '../Deliveries/DeliveriesStore';

export class AttachmentStore {
    private static _instance = new AttachmentStore();
    public static get instance() { return AttachmentStore._instance; }

    async addAttachment(deliveryIdentifier: DeliveryIndentifier, imageBase64: string, imageFormat: string) {
        const body = {
            orderNo: deliveryIdentifier.orderNo,
            base64: imageBase64,
            format: imageFormat
        };

        const response = await fetch(`${UrlProvider.root}/api/attachments`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });

        const attachResponse = await response.json();
        if (response.ok) { 
            await CommentsStore.instance.addComment(deliveryIdentifier, `Picture ${attachResponse.id} added. (system)`);
        }
    }
}